import { FunctionComponent ,useEffect, useState,useRef, useContext} from "react";
import styles from "./SearchDropdown.module.css";
import images from "../../../../assets/images/index";
import { useNavigate } from "react-router";
import { User } from "../../table/AppTable";
import { globalContext } from "../../../../Provider/AppProvider";

interface SearchDropdownProps {
  searchResult: any;
  handleSearchClick : (searchInput: User) => void;
  searchInput : string
  finalsearch : string
  setFinalsearch : (value : string) => void
  setEmail: (value: boolean) => void
  email : boolean
}


const SearchDropdown: FunctionComponent<SearchDropdownProps> = ({
  searchResult, handleSearchClick, searchInput, finalsearch , setFinalsearch, setEmail, email
}) => {

  const {
    searchTicketIcon, searchUserIcon, AffiliateIcon, DefaultProfile, MLB, MLS, NHL, Football, Basketball
  } = images;
  const frontEndUrl = process.env.REACT_APP_FRONTEND_URL;
  const [selectedIndex, setSelectedIndex] = useState(0);
  const navigate = useNavigate()
  const containerRef = useRef<HTMLDivElement | null>(null); 
  const {handleGlobalState,globalState} = useContext<any>(globalContext)
  

  const BoldSearchTerm = (text : string) => {
    // Split the text based on the search term to preserve its case
    const parts = text?.split(new RegExp(`(${searchInput})`, 'gi'));
  
    return (
      <div className={email ? styles.searchdivemail :  styles.searchdiv} data-testid='selectdropdown'>
      <span>
        {parts?.map((part, index) =>
          part.toLowerCase() === searchInput.toLowerCase() ? (
            <b key={index} className={styles.bold} >{part}</b>
          ) : (
            part
          )
        )}
      </span>
      </div>
    );
  };

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      const combinedResults = [].concat(
        searchResult?.user ?? [],
        searchResult?.events ?? [],
        searchResult?.league_categories ?? [],
        searchResult?.affiliates ?? []
      );
  
      switch (event.key) {
        case 'ArrowUp':
          event.preventDefault();
          setSelectedIndex((prevIndex) => Math.max(prevIndex - 1, 0));
          scrollItemIntoView(Math.max(selectedIndex - 1, 0));
          break;
        case 'ArrowDown':
          event.preventDefault();
          setSelectedIndex((prevIndex) =>
            Math.min(prevIndex + 1, combinedResults.length - 1)
          );
          scrollItemIntoView(Math.min(selectedIndex + 1, combinedResults.length - 1));
          break;
        case 'Enter':
          if (selectedIndex !== -1) {
            const selectedItem : any= combinedResults[selectedIndex];
            handleSearchClick(selectedItem);
            const target = event.target as HTMLElement;
            if (target.classList.contains(styles.manageTicketCta)) {
              navigate('/tickets');
            } else if (target.classList.contains(styles.manageUserCta)) {
              navigate('/users');
            } else {
              if(selectedItem?.u_full_name){
                navigate('/users');
              } else if(selectedItem?.user?.u_full_name){
                  navigate('/affiliate')
              } else if((selectedItem?.e_name) || (selectedItem?.lc_name)){
                navigate('/tickets');
              }
            }
          }
          break;
        case 'Backspace':
          const tempstate = { ...globalState };
          tempstate.globalSearch.searchtext = '';
          handleGlobalState(tempstate);
          setFinalsearch('');
          setEmail(false);
          break;
        default:
          break;
      }
    };
  
    document.addEventListener('keydown', handleKeyPress);
  
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIndex, searchResult, handleSearchClick, globalState, handleGlobalState, setFinalsearch, navigate]);
  
  const scrollItemIntoView = (index: number) => {
    const container = containerRef.current as unknown as HTMLDivElement;
  
    if (container) {
      const item = container.children[index] as HTMLElement;
  
      if (item) {
        item.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        });
      }
    }
  };

  const navigatePage = (data: any) => {
    if(data?.u_full_name){
      navigate('/users');
    }else if(data?.e_name || data?.lc_name){
      navigate('/tickets');
    }else if(data?.user?.u_full_name){
      navigate('/affiliate')
    }
  }

  const handleProfileImageSrc = (data: any) => {
    let src ='';
    if(data?.lc_name){
      if(data?.lc_avatar_url){
        return (
          <img className={styles.leagueImageContainer} alt="leagueCategory" src={`${frontEndUrl}${data?.lc_avatar_url}`}/>
        )
       }else {
        return (
          <>
            <div className={styles.leagueImageDiv} style={{backgroundColor: `${data?.lc_colour_code}`}}>
              <p className={data?.lc_abbrev?.length <= 4 ? styles.subStyle : styles.lengthFiveSubStyle}>{data?.lc_abbrev}</p>
            </div>
          </>
        );
       }
    }else {
      if(data?.u_full_name){
        if(data?.u_avatar_url){
          src = `${data?.u_avatar_url}`;
        }else{
          src = DefaultProfile;
        }
      }else if(data?.e_name){
        if(data?.e_image_url){
          src = `${data?.e_image_url}`;
        } else if (data?.event_categories) {
          if (data?.event_categories[0]?.league_category?.league?.l_name === "MLB") {
            src = MLB
          } else if (data?.event_categories[0]?.league_category?.league?.l_name === "MLS") {
            src = MLS
          } else if (data?.event_categories[0]?.league_category?.league?.l_name === "NBA"||data?.event_categories[0]?.league_category?.league?.l_name === "NCAAM"||data?.event_categories[0]?.league_category?.league?.l_name === "NCAAW"||data?.event_categories[0]?.league_category?.league?.l_name === "WNBA") {
            src = Basketball
          } else if (data?.event_categories[0]?.league_category?.league?.l_name === "NCAAFB"||data?.event_categories[0]?.league_category?.league?.l_name === "NFL") {
            src = Football
          } else if (data?.event_categories[0]?.league_category?.league?.l_name === "NHL") {
            src = NHL
          }else {
            src = DefaultProfile;
          }
        }else{
          src = DefaultProfile;
        }
      }
    }
    const leagueName = data?.event_categories?.[0]?.league_category?.league?.l_name
    return (<img className={(leagueName === "NHL" || leagueName === "NFL" || leagueName === "NCAAFB") ? styles.NHLImg : styles.imgIcon} alt="" src={src} />);
  }

  return (
    <>
      {searchResult &&
        (((searchResult?.user?.length > 0)|| (searchResult?.events?.length > 0) ||  (searchResult?.league_categories?.length > 0) || (searchResult?.affiliates?.length > 0)) ?  (
          <div className={styles.searchDropdown} >
            <div className={styles.searchResults} ref={containerRef} >
              {(globalState.profile.userRole === "marketing_user"?[].concat(searchResult?.user, searchResult?.affiliates):(globalState.profile.userRole==="logitix_user" || globalState.profile.userRole === "super_user")?[].concat(searchResult?.events, searchResult?.league_categories):[].concat(searchResult?.user, searchResult?.events, searchResult?.league_categories, searchResult?.affiliates))?.map((data: any,index : number) => {
                 const isSelected = index === selectedIndex;
                return (
                  <div
                    className={`${styles.searchBg1} ${isSelected ? styles.selectedItem : ''}`}
                    onClick={() => handleSearchClick(data)}
                    key={data?.id}
                    data-testid = 'selectdropdown'
                  >
                    {/* <img className={styles.imgIcon} alt="" src={data?.u_full_name? userProfile9: data?.lc_name? TeamProfile: DefaultProfile } /> */}
                    {(data?.user?.u_full_name ||data?.events?.e_name) && data?.user?.u_full_name ? '' : handleProfileImageSrc(data)}
                    <div className={styles.searchSuggestion}  onClick={()=> navigatePage(data)}>
                      <div className={styles.container}>
                        <b className={styles.houstonRockets}>
                          <span className={styles.houry0245Txt}>
                            {BoldSearchTerm(data?.u_full_name ?? data?.e_name ?? data?.lc_name ?? data?.user?.u_full_name)}
                            {searchInput.includes("@") && (
                              <span className={styles.mailId}>
                                - {data?.u_email_id ? BoldSearchTerm(data?.u_email_id) : BoldSearchTerm(data?.a_email_id)}
                              </span>
                            )}
                          </span>
                        </b>
                      </div>
                    </div>
                    <div className={`${styles.cta} ${isSelected ? styles.ctahover : ''}` }>
                      {globalState.profile.userRole !== "marketing_user" && (data?.e_name || data?.lc_name || data?.u_full_name) ? <div className={styles.manageTicketCta} tabIndex={isSelected ? 0 : -1} onClick={()=> navigate('/tickets')}>
                        <img
                          className={styles.sharpOutlineTicket}
                          alt="ticketIcon"
                          src={searchTicketIcon}
                        />
                      </div> : ''}
                      {data?.u_full_name ? <div className={styles.manageUserCta} tabIndex={isSelected ? 0 : -1} onClick={()=> navigate('/users')}>
                        <img
                          className={styles.sharpOutlineTicket}
                          alt="UserIcon"
                          src={searchUserIcon}
                        />
                      </div> : ''}
                      {data?.user?.u_full_name ? <div className={styles.manageUserCta} tabIndex={isSelected ? 0 : -1} onClick={()=> navigate('/affiliate')}>
                        <img
                          className={styles.sharpOutlineTicket}
                          alt="AffiliateIcon"
                          src={AffiliateIcon}
                        />
                      </div> : ''}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <>
            <div className={styles.searchDropdownNoData}>
              <div className={styles.searchResults}>
                <div className={styles.nodata}>No data found</div>
              </div>
            </div>
          </>
        ))}
    </>
  );
};

export default SearchDropdown;
